"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertNumberIndicator = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
var AlertNumberIndicator = function AlertNumberIndicator(props) {
  var className = props.className,
    alertNumber = props.alertNumber;
  return react_1.default.createElement("div", {
    className: classnames_1.classNames(className, vdl_prefix_1.vdlPrefix('alert-number-indicator'))
  }, alertNumber);
};
exports.AlertNumberIndicator = AlertNumberIndicator;
exports.AlertNumberIndicator.propTypes = {
  alertNumber: prop_types_1.default.number,
  className: prop_types_1.default.string
};
exports.AlertNumberIndicator.displayName = 'AlertNumberIndicator';